import { Controller } from "@hotwired/stimulus"

// Shows the Ausbildungszeitraum while the picked Mitarbeitertyp has the Beschäftigungsart Azubi
// (the option's data-employment-category, see EmployeesHelper#employee_type_grouped_options).
export default class extends Controller {
  static targets = ["typeSelect", "traineeFields"]

  connect() {
    this.toggleTraineeFields()
  }

  toggleTraineeFields() {
    const option = this.typeSelectTarget.selectedOptions[0]
    const trainee = option?.dataset.employmentCategory === "trainee"
    this.traineeFieldsTarget.classList.toggle("hidden", !trainee)
  }
}
